interface LogoProps {
  size?: "sm" | "md" | "lg";
  variant?: "full" | "icon";
  className?: string;
}

export function Logo({
  size = "md",
  variant = "full",
  className = "",
}: LogoProps) {
  const sizeClasses = {
    sm: variant === "full" ? "h-6" : "h-6 w-6",
    md: variant === "full" ? "h-8" : "h-8 w-8",
    lg: variant === "full" ? "h-10" : "h-10 w-10",
  };

  if (variant === "icon") {
    return (
      <div
        className={`flex items-center justify-center bg-primary text-white rounded-md ${sizeClasses[size]} ${className}`}
      >
        <span className="font-bold">LB</span>
      </div>
    );
  }

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div
        className={`flex items-center justify-center bg-primary text-white rounded-md ${
          size === "sm"
            ? "h-6 w-6"
            : size === "md"
            ? "h-8 w-8"
            : "h-10 w-10"
        }`}
      >
        <span className="font-bold">LB</span>
      </div>
      <span
        className={`font-bold ${
          size === "sm"
            ? "text-lg"
            : size === "md"
            ? "text-xl"
            : "text-2xl"
        }`}
      >
        Logistics Buddy
      </span>
    </div>
  );
}
